export enum Type {
    BANK_CARD = 1,
    CASHLESS_VAT = 2,
    CASHLESS_VATLESS = 3,
}
